import "./RSVP.module.css";
import DropshippingHero from "@/reusable_sections/Header";
import ContributorApplication from "./sections/ContributorApplication";
import ContactDetails from "./sections/ContactDetails";
import BrandFooter from "@/reusable_sections/Footer";
export default function RSVPPage() {
  return <div>
      <DropshippingHero />
      <ContributorApplication />
      <ContactDetails />
      <BrandFooter />
    </div>;
}